<h3 class="body-400">Throttling</h3>

<mat-checkbox [formControl]="checkControl" (change)="onCheckboxChange($event.checked)">
  Require a minimum of
  <input
    type="text"
    class="throttling-minimum-days-input"
    [ngClass]="{ 'throttling-minimum-days-input-invalid': daysControl.invalid && (daysControl.touched || daysControl.dirty) }"
    [formControl]="daysControl"
    (change)="$event.stopPropagation()"
    maxlength="3"
    min="1"
    numberOnly
  />
  days before sending another statement to a {{ statementRecipientLabel$ | async }}
</mat-checkbox>

<mat-error *ngIf="daysControl.invalid && (daysControl.touched || daysControl.dirty)" class="throttling-minimum-days-input-error">
  {{ errorMessage }}
</mat-error>
